import { createRoot } from 'react-dom/client';
import { App } from './App.jsx';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';
import './ui.css';
import './branding/portal-branding.css';
import './onboarding/onboarding.css';

const el = document.getElementById('root');
if (el) {
  createRoot(el).render(<App />);
}
